document.addEventListener('DOMContentLoaded', function() {
  const firstLine = document.getElementById('firstLine')
  const secondLine = document.getElementById('secondLine')
  const firstText = 'MBA × WEB MARKETING・SEO × AI'
  const secondText = 'KAZUYA IKEDA'

  let firstIndex = 0
  let secondIndex = 0
  const typingSpeed = 100 // 1文字あたりの表示速度（ミリ秒）

  function typeFirstLine() {
    if (firstIndex < firstText.length) {
      firstLine.textContent += firstText.charAt(firstIndex)
      firstIndex++
      setTimeout(typeFirstLine, typingSpeed)
    } else {
      // 1行目が完了したら2行目の表示を開始
      setTimeout(typeSecondLine, typingSpeed)
    }
  }

  function typeSecondLine() {
    if (secondIndex < secondText.length) {
      secondLine.textContent += secondText.charAt(secondIndex)
      secondIndex++
      setTimeout(typeSecondLine, typingSpeed)
    }
  }

  // 1行目の表示を開始
  typeFirstLine()
})
